import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "flex justify-end gap-2" }

import { t } from 'i18next';
import { computed, ref } from 'vue';
import { Dialog, Button, Message } from 'primevue';
import { DIALOG_TEXT_TYPE, DIALOG_TYPE } from './constants';


export default /*@__PURE__*/_defineComponent({
  __name: 'VueDialog',
  props: {
    title: {},
    message: {},
    type: {},
    textType: {},
    onClose: { type: Function }
  },
  setup(__props: any) {

const props = __props;
const visible = ref(true);
const severityValues = {
  [DIALOG_TEXT_TYPE.INFO]: 'info',
  [DIALOG_TEXT_TYPE.WARNING]: 'warn',
  [DIALOG_TEXT_TYPE.ERROR]: 'error',
  [DIALOG_TEXT_TYPE.SUCCESS]: 'success',
};
const severity = computed(() => {
  if (props.textType) {
    return severityValues[props.textType];
  }

  return null;
});
const onCloseDialog = (answer: boolean): void => {
  visible.value = false;
  props.onClose(answer);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: visible.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    modal: "",
    header: _ctx.title,
    style: { width: '35rem' },
    onHide: _cache[3] || (_cache[3] = ($event: any) => (onCloseDialog(false)))
  }, {
    default: _withCtx(() => [
      (severity.value)
        ? (_openBlock(), _createBlock(_unref(Message), {
            key: 0,
            severity: severity.value,
            variant: "simple",
            size: "small",
            class: "modal-body my-4",
            innerHTML: _ctx.message
          }, null, 8, ["severity", "innerHTML"]))
        : _createCommentVNode("", true),
      (!severity.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "modal-body my-4",
            innerHTML: _ctx.message
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Button), {
          type: "button",
          label: _unref(t)('components.dialog.ok'),
          severity: "secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onCloseDialog(true)))
        }, null, 8, ["label"]),
        (_ctx.type === _unref(DIALOG_TYPE).CONFIRM)
          ? (_openBlock(), _createBlock(_unref(Button), {
              key: 0,
              type: "button",
              label: _unref(t)('components.dialog.cancel'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (onCloseDialog(false)))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "header"]))
}
}

})